import { layoutMarginSmall, ProductButton, ProductParagraph } from '@issuu/silkscreen';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';
import { truncateText } from '../shared/truncate-text';

const SeeMoreBox = styled.span`
    margin-left: 0.5em;
    > button {
        text-transform: uppercase;
    }
`;
const PublicationDescription = styled.div`
    padding-top: ${layoutMarginSmall};
    overflow-wrap: anywhere;
`;

const DESCRIPTION_CUTOFF = 150;
export const Description: React.FC = () => {
    const {
        document: { description },
        crawler,
    } = useContext(DocumentContext);
    const isDescriptionTruncated = description.length > DESCRIPTION_CUTOFF;

    // showFullDescription value is only meaningful when description gets truncated
    const [showFullDescription, setShowFullDescription] = useState<boolean>(
        !isDescriptionTruncated || !!crawler,
    );

    const toggleDescLength = () => setShowFullDescription(!showFullDescription);

    const descriptionContent = description.length ? (
        <ProductParagraph>
            {showFullDescription ? description : truncateText(DESCRIPTION_CUTOFF, description)}
            {isDescriptionTruncated ? (
                <>
                    {' '}
                    <SeeMoreBox>
                        <ProductButton onClick={toggleDescLength} size="small" variant="ghost">
                            {showFullDescription ? 'See Less' : 'See More'}
                        </ProductButton>
                    </SeeMoreBox>
                </>
            ) : null}
        </ProductParagraph>
    ) : (
        <ProductParagraph>No description</ProductParagraph>
    );

    return <PublicationDescription>{descriptionContent}</PublicationDescription>;
};
